import { createSlice } from "@reduxjs/toolkit";
import { LOGO_SLICE } from "../constants";

const initialState = {
  logo: "",
};
export const LogoSlice = createSlice({
  name: LOGO_SLICE,
  initialState,
  reducers: {
    addLogoToUrl: (state, action) => {
      const data = {
        ...state,
        logo: action.payload,
      };
      return (state = data);
    },
  },
});

export const { addLogoToUrl } = LogoSlice.actions;

export default LogoSlice.reducer;
